(function () {
  function initSlider(root) {
    if (!root || root.dataset.tpReady === 'true') return;
    root.dataset.tpReady = 'true';

    var viewport = root.querySelector('[data-tp-viewport]');
    var track = root.querySelector('[data-tp-track]');
    var prevBtn = root.querySelector('[data-tp-prev]');
    var nextBtn = root.querySelector('[data-tp-next]');
    var dotsWrap = root.querySelector('[data-tp-dots]');
    if (!viewport || !track) return;

    // Only original cards (ignore prior clones from theme editor reloads)
    track.querySelectorAll('[data-tp-clone]').forEach(function (node) {
      node.remove();
    });

    var originalCards = Array.prototype.slice.call(track.children);
    if (!originalCards.length) return;

    var autoplay = root.getAttribute('data-tp-autoplay') !== 'false';
    var delay = parseInt(root.getAttribute('data-tp-delay') || '4500', 10);
    if (!delay || delay < 2000) delay = 4500;

    var index = 0;
    var perView = 1;
    var pages = 1;
    var timer = null;
    var animating = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function calcPerView() {
      var w = window.innerWidth;
      if (w >= 990) return Math.min(3, originalCards.length);
      if (w >= 750) return Math.min(2, originalCards.length);
      return 1;
    }

    function stepSize() {
      var cardWidth = originalCards[0].getBoundingClientRect().width;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return cardWidth + gap;
    }

    function buildClones() {
      track.querySelectorAll('[data-tp-clone]').forEach(function (node) {
        node.remove();
      });

      // Clone a full set so we can keep scrolling forward forever without snapping back
      originalCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-tp-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tp-reviews__dot' + (i === (index % pages) ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.setAttribute('data-tp-dot', String(i));
        dotsWrap.appendChild(btn);
      }
    }

    function setOffset(i, animate) {
      if (animate === false) {
        track.classList.add('is-instant');
      } else {
        track.classList.remove('is-instant');
      }
      track.style.transform = 'translate3d(' + -(i * stepSize()) + 'px, 0, 0)';
      if (animate === false) {
        // Force reflow so next animated move works
        void track.offsetWidth;
        track.classList.remove('is-instant');
      }
    }

    function syncDots() {
      if (!dotsWrap || !pages) return;
      var active = ((index % pages) + pages) % pages;
      dotsWrap.querySelectorAll('[data-tp-dot]').forEach(function (dot) {
        var i = parseInt(dot.getAttribute('data-tp-dot'), 10);
        dot.classList.toggle('is-active', i === active);
      });
    }

    function updateLayout() {
      perView = calcPerView();
      // One dot per card so the infinite 1-step loop stays in sync
      pages = Math.max(1, originalCards.length);
      if (index >= originalCards.length) index = index % originalCards.length;
      if (index < 0) index = 0;

      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('[data-tp-dot]');
        if (dots.length !== pages) buildDots();
      }
      setOffset(index, false);
      syncDots();

      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    function onTransitionEnd(event) {
      if (event.target !== track || event.propertyName !== 'transform') return;
      animating = false;

      // After scrolling into the cloned half, jump back by one full set with no animation
      if (index >= originalCards.length) {
        index = index - originalCards.length;
        setOffset(index, false);
      } else if (index < 0) {
        index = index + originalCards.length;
        setOffset(index, false);
      }
      syncDots();
    }

    function goTo(i, animate) {
      if (animating && animate !== false) return;
      index = i;
      if (animate !== false) animating = true;
      setOffset(index, animate !== false);
      syncDots();
    }

    function next() {
      goTo(index + 1, true);
    }

    function prev() {
      // Move into negative range via cloned positioning: jump to clone equivalent first if at start
      if (index <= 0) {
        index = originalCards.length;
        setOffset(index, false);
      }
      goTo(index - 1, true);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoplay || reduceMotion || originalCards.length <= perView) return;
      timer = setInterval(next, delay);
    }

    buildClones();
    track.addEventListener('transitionend', onTransitionEnd);

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-tp-dot]');
        if (!dot) return;
        var target = parseInt(dot.getAttribute('data-tp-dot'), 10);
        var currentPage = ((index % pages) + pages) % pages;
        // Always move forward toward the target page for a continuous feel
        var delta = (target - currentPage + pages) % pages;
        goTo(index + delta, true);
        start();
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    var touchX = null;
    viewport.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (touchX == null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) {
        if (dx < 0) next();
        else prev();
      }
      touchX = null;
      start();
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateLayout();
      start();
    });

    buildDots();
    updateLayout();
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-tp-reviews]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      (event.target && event.target.querySelector && event.target.querySelector('[data-tp-reviews]')) ||
      (event.target && event.target.hasAttribute && event.target.hasAttribute('data-tp-reviews')
        ? event.target
        : null);
    if (root) {
      root.dataset.tpReady = 'false';
      initSlider(root);
    }
  });
})();
